// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import Drrp360TaskIconOutlinedSvg from "@fishx/icons-svg/es/asn/Drrp360TaskIconOutlined";
import FishxIcon from '../components/FishxIcon';

var Drrp360TaskIconOutlined = function Drrp360TaskIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: Drrp360TaskIconOutlinedSvg
  }));
};

Drrp360TaskIconOutlined.displayName = 'Drrp360TaskIconOutlined';
export default React.forwardRef(Drrp360TaskIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/Drrp360TaskIconOutlined.js
// module id = 2490
// module chunks = 0